import { RegionShort } from 'utils/internationalization'

//copied from footer here as footer is marked as legacy, and it might be deleted.
export const getPhoneNumber = (region: RegionShort) => {
	switch (region) {
		case 'eu':
		case 'au':
		case 'se':
		case 'dk':
			return {
				link: 'tel:+34 5 18 90 04 68',
				string: '+34 5 18 90 04 68',
			}
		case 'uk':
			return {
				link: 'tel:+443308186258',
				string: '+44 (0) 330 818 6258',
			}
	}

	return {
		link: 'tel:+18886994015',
		string: '+1 (888) 699-4015',
	}
}
